var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5456_10860)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9931 5.99656L0 11.9931L6.00001 17.9966L12 24L18 17.9966L24 11.9931L18.0069 5.99656C14.7107 2.69845 12.0076 0 12 0C11.9924 0 9.28929 2.69845 5.9931 5.99656ZM7.21928 7.22344L2.45236 11.9931L7.22619 16.7697L12 21.5462L16.7738 16.7697L21.5476 11.9931L16.7807 7.22344C14.1589 4.60012 12.0076 2.45376 12 2.45376C11.9924 2.45376 9.84107 4.60012 7.21928 7.22344ZM11.1458 10.1183V13.6198H12H12.8542V10.1183V6.61689H12H11.1458V10.1183ZM11.1458 16.5698V17.3693H12H12.8542V16.5698V15.7703H12H11.1458V16.5698Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5456_10860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningDiamond);
export default __webpack_public_path__ + "static/media/icon--warning-diamond.70f9351a0795da8507bbc7d366107c89.svg";
export { ForwardRef as ReactComponent };